import { TransparentButtonLarge } from 'components/button/button.styled'
import React from 'react'
import { getSeasonText } from 'utils/event'

import { Container, Text } from './selectSeason.style'

interface SelectSeasonProps {
    season: number | string
    onPreviousYear: () => void
    onNextYear: () => void
}

export const SelectSeason: React.FC<SelectSeasonProps> = ({ season, onPreviousYear, onNextYear }) => {
    return (
        <Container>
            <TransparentButtonLarge icon="pi pi-chevron-left" onClick={onPreviousYear} />
            <Text>{`${getSeasonText(season)}`}</Text>
            <TransparentButtonLarge icon="pi pi-chevron-right" onClick={onNextYear} />
        </Container>
    )
}
